// API Manager to prevent duplicate API calls across the entire application
class ApiManager {
  constructor() {
    this.callsInProgress = new Set();
    this.completedCalls = new Set();
  }

  // Check if an API call is already in progress or completed
  isCallInProgress(endpoint) {
    return this.callsInProgress.has(endpoint) || this.completedCalls.has(endpoint);
  }

  // Mark an API call as started
  startCall(endpoint) {
    this.callsInProgress.add(endpoint);
  }

  // Mark an API call as completed
  completeCall(endpoint) {
    this.callsInProgress.delete(endpoint);
    this.completedCalls.add(endpoint);
  }

  // Reset all flags (useful for testing or page refresh)
  reset() {
    this.callsInProgress.clear();
    this.completedCalls.clear();
  }

  // Reset a specific endpoint (useful for allowing re-fetching of specific data)
  resetCall(endpoint) {
    this.callsInProgress.delete(endpoint);
    this.completedCalls.delete(endpoint);
  }

  // Reset all endpoint variations that start with the base endpoint
  // Useful for endpoints with query parameters
  resetCallVariations(baseEndpoint) {
    // Reset base endpoint
    this.resetCall(baseEndpoint);
    
    // Reset all variations that start with baseEndpoint
    const endpointsToReset = [];
    this.callsInProgress.forEach(endpoint => {
      if (endpoint.startsWith(baseEndpoint)) {
        endpointsToReset.push(endpoint);
      }
    });
    this.completedCalls.forEach(endpoint => {
      if (endpoint.startsWith(baseEndpoint)) {
        endpointsToReset.push(endpoint);
      }
    });
    
    endpointsToReset.forEach(endpoint => {
      this.resetCall(endpoint);
    });
  }

  // Get status of all calls
  getStatus() {
    return {
      inProgress: Array.from(this.callsInProgress),
      completed: Array.from(this.completedCalls)
    };
  }
}

// Export singleton instance
export const apiManager = new ApiManager();
export default apiManager;
